import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const NewBoard = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 3H6.49998L6.49998 13.5H2.5L2.5 3ZM1.5 3C1.5 2.44772 1.94772 2 2.5 2H6.49998C7.05227 2 7.49998 2.44772 7.49998 3V13.5C7.49998 14.0523 7.05227 14.5 6.49998 14.5H2.5C1.94771 14.5 1.5 14.0523 1.5 13.5V3ZM9.49998 3H13.5V12.5H9.49998V3ZM8.49998 3C8.49998 2.44772 8.9477 2 9.49998 2H13.5C14.0523 2 14.5 2.44772 14.5 3V12.5C14.5 13.0523 14.0523 13.5 13.5 13.5H9.49998C8.9477 13.5 8.49998 13.0523 8.49998 12.5V3Z"
        fill={color}
      />
      <circle cx="12.5" cy="12.5" r="3.5" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 10.5C13 10.2239 12.7761 10 12.5 10C12.2239 10 12 10.2239 12 10.5V12H10.5C10.2239 12 10 12.2239 10 12.5C10 12.7761 10.2239 13 10.5 13H12V14.5C12 14.7761 12.2239 15 12.5 15C12.7761 15 13 14.7761 13 14.5V13H14.5C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12H13V10.5Z"
      />
      <path
        d="M14 3H9V11C9 11.5523 9.44772 12 10 12L13 12C13.5523 12 14 11.5523 14 11V3Z"
        fill="#2D425B"
        fillOpacity="0.05"
      />
      <path d="M7 3H2V13C2 13.5523 2.44772 14 3 14L6 14C6.55228 14 7 13.5523 7 13V3Z" fill={color} fillOpacity="0.05" />
    </svg>
  )
})

export default NewBoard
